import axios from 'axios';
 
class SignatureService { 

  getVerifyIdvStatus() { 
    return axios.get(`document-signature/verify-idv-status`); 
  } 

  getUrlDocusign(legalName) { 
    return axios.post(`document-signature/get-idv-url`, {
      legal_name: legalName
    }); 
  } 

  putSignature(id) { 
    return axios.put(`document-signature/save-idv-token`, {
      envelopeId: id
    }); 
  }

  putSignatureNDA(envelopId, programId) { 
    return axios.put(`/document-signature/save-nda-signature`, {
      envelopeId: envelopId,
      programId: programId
    }); 
  }

  getNeedsNDA(programId) { 
    return axios.get(`document-signature/needs-nda-signature/program/${programId}`); 
  } 

  getUrlSignatureNDA(programId) { 
    return axios.get(`document-signature/get-nda-signature-url/program/${programId}`); 
  } 


}

export default new SignatureService();